var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BrokerLogs',{attrs:{"selectedPModuleIds":_vm.selectedPModuleIds,"apiStore":_vm.apiStore,"onlyPModuleEventTypes":true}})}
var staticRenderFns = []

export { render, staticRenderFns }